<template>
  <modal :opened="modalFilaPrint">
    <div style="max-height: 400px; overflow: auto">
      <div class="text-center border-bottom pb-2 mb-2">
        <i class="fa fa-print"></i> {{ printServer ? 'Servidor de Impressão' : 'Fila de Impressão' }}
      </div>
      <div v-show="prints.length" style="min-height: 167px">
        <table class="table table-sm small">
          <tr>
            <th>Impressão</th>
            <th>&nbsp;</th>
          </tr>
          <tr v-for="p in prints">
            <td class="align-middle">
              <b>{{p.nome_documento}}</b>
              <div><img src="../../assets/icons/clock.svg" class="icon-previsao"> {{p.created_at.slice(-8, -3)}}</div>
              <div v-if="usaNovaImpressao ? Number(p.status) === 4 : p.status > 1" class="small text-ellipsis">Erro: {{p.erro || 'Não foi possível imprimir'}}</div>
              <div v-else-if="usaNovaImpressao && Number(p.status) === 2" class="small text-ellipsis">Em processamento</div>
              <div class="small text-ellipsis" v-else>Aguardando impressão</div>
            </td>
            <td class="text-right align-middle text-nowrap">
              <a href="javascript:" class="btn btn-sm text-info" title="Reimprimir" @click="reemprimirFila(p)" v-if="printServer">
                <i class="fa fa-print"></i>
              </a>
              <a href="javascript:" class="btn btn-sm text-info text-danger" title="Remover impressão" @click="removerFila(p)">
                <i class="fa fa-trash-alt"></i>
              </a>
            </td>
          </tr>
        </table>
      </div>
      <div class="p-4 text-center mb-3" v-show="!prints.length">
        <div class="mb-4" v-if="printServer || load">
          <loading :text="load ? `Por favor aguarde` : `Aguardando novas solicitações`"/>
        </div>
        <p class="m-0 small" v-else>Nenhum pedido na fila de impressão</p>
      </div>
    </div>
    <div class="text-center pt-3 border-top">
      <button class="btn btn-dark" @click="$store.state.modalFilaPrint = false">Fechar</button>
    </div>
  </modal>
</template>

<script>
  import Modal from "./ModalGestor";
  import Loading from "@/components/commons/Loading";

  export default {
    name: "ModalFila",
    components: {Loading, Modal},
    props: ['printServer', 'token'],

    data() {
      return {
        prints: [],
        erros: 0,
        load: false,
        filaTimeOut: null,
        offline: [],
        acompanhandoRemotas: false,
        acompanhamentoCancelado: false,
        avisosRemotos: []
      }
    },

    methods: {
      async consultarImpressoesRemotas(ids) {
        try {
          const res = await this.$http.post('v2/impressao/acompanhamento', { ids_impressao: ids });
          if (!Array.isArray(res.data)) throw new Error('Resposta inválida ao consultar impressões');
          const porId = new Map(res.data.map(registro => [Number(registro.id_impressao), registro]));
          return {
            registros: ids.map(id => porId.get(id) || {
              id_impressao: id, status: null, erro: 'Registro da impressão não encontrado.'
            }),
            consultaFalhou: false
          };
        } catch (erro) {
          return { registros: [], consultaFalhou: true };
        }
      },

      async acompanharRemotas() {
        if (this.acompanhamentoCancelado || !this.usaNovaImpressao || this.printServer || this.acompanhandoRemotas || !this.impressoesRemotas.length) {
          return;
        }

        this.acompanhandoRemotas = true;
        const tentativas = new Map();

        try {
          while (!this.acompanhamentoCancelado && this.usaNovaImpressao && !this.printServer && this.impressoesRemotas.length) {
            // Só os IDs separados antes da espera entram nesta rodada.
            const ids = this.impressoesRemotas.slice();

            await new Promise(resolve => setTimeout(resolve, 15000));

            if (this.acompanhamentoCancelado || !this.usaNovaImpressao || this.printServer) {
              return;
            }

            const problemas = [];
            const idsFalhaConsulta = [];
            let enviadaParaImpressao = false;

            for (let inicio = 0; inicio < ids.length; inicio += 100) {
              const lote = ids.slice(inicio, inicio + 100);
              const resultado = await this.consultarImpressoesRemotas(lote);

              if (this.acompanhamentoCancelado || !this.usaNovaImpressao || this.printServer) {
                return;
              }

              const finalizados = [];

              lote.forEach(id => {
                const tentativa = (tentativas.get(id) || 0) + 1;
                tentativas.set(id, tentativa);

                if (resultado.consultaFalhou) {
                  if (tentativa >= 3) {
                    idsFalhaConsulta.push(id);
                    finalizados.push(id);
                  }

                  return;
                }

                const registro = resultado.registros.find(item => Number(item.id_impressao) === id);
                const status = Number(registro.status);

                if ([2, 3].includes(status)) {
                  enviadaParaImpressao = true;
                }

                if (![1, 2].includes(status) || tentativa >= 3) {
                  finalizados.push(id);

                  if (![3, 5].includes(status)) {
                    problemas.push(registro);
                  }
                }
              });

              this.$store.commit('finalizarAcompanhamentoRemoto', finalizados);
              finalizados.forEach(id => tentativas.delete(id));
            }

            if (problemas.length || idsFalhaConsulta.length) {
              this.$store.state.printsError = 1;
            } else if (enviadaParaImpressao) {
              this.$store.state.printsError = 0;
            }

            this.avisarImpressoesRemotas(problemas, idsFalhaConsulta);
          }
        } finally {
          this.acompanhandoRemotas = false;
        }
      },

      avisarImpressoesRemotas(problemas, idsFalhaConsulta) {
        const idsAviso = [...problemas.map(registro => Number(registro.id_impressao)), ...idsFalhaConsulta];
        const novos = idsAviso.filter(id => !this.avisosRemotos.includes(id));
        if (!novos.length) return;
        this.avisosRemotos.push(...novos);

        const mensagens = problemas.filter(registro => novos.includes(Number(registro.id_impressao))).map(registro => {
          const nome = registro.nome_documento || 'Impressão';
          if ([1, 2].includes(Number(registro.status))) return `${nome}: ainda pendente ou em processamento.`;
          return `${nome}: ${registro.erro || 'A impressão não foi concluída.'}`;
        });
        const consultaFalhou = idsFalhaConsulta.some(id => novos.includes(id));
        if (consultaFalhou) mensagens.push('Não foi possível confirmar o status de todas as impressões. Isso não confirma uma falha.');
        this.$swal({
          title: consultaFalhou ? 'Verificar impressão' : problemas.some(registro => Number(registro.status) === 4) ? 'Erro ao imprimir' : 'Verificar impressão',
          text: mensagens.join('\n'),
          buttons: this.modalFilaPrint ? 'Ok' : ['Fechar', 'Abrir fila de impressão']
        }).then(abrir => {
          if (abrir && !this.acompanhamentoCancelado) this.$store.state.modalFilaPrint = true;
        });
      },

      getFilaImpressao(print) {
        if (this.load) {
          return;
        }

        this.load = true;
        this.prints = []
        this.setFilaOffline();

        this.$http.get(`pdv/fila-impressao?key=${this.token}`)
          .then(response => {
            if (!response.data) {
              this.load = false;
              return;
            }

            this.prints = response.data || [];
            const dataPrints = this.prints.filter(p => p.status === '1');
            this.$store.state.printsError = this.printServer ? this.prints.filter(p => p.status !== '1').length : this.prints.length;

            if (print && dataPrints.length) {
              this.setFilaImpressao(dataPrints.map(p => { return { status: 2, id_impressao: p.id_impressao }}), () => {
                const detail = [];

                dataPrints.forEach(p => {
                  p.content.id_impressao = p.id_impressao;

                  if (!this.usaNovaImpressao) {
                    p.content.impressora = {
                      device: p.device ? p.device : this.impressora.device,
                      largura: p.content.largura ? p.content.largura : this.impressora.largura,
                      zoom: p.content.zoom ? p.content.zoom : this.impressora.zoom,
                      id_cozinha: p.content.id_cozinha || null
                    };
                  }

                  detail.push(p.content);
                });

                document.dispatchEvent(new CustomEvent(this.eventoImpressao, { detail }));
              });

            } else {
              this.load = false;
            }

          }, res => {
            console.log(res)
            this.load = false;
            this.$swal(res.data.msg ? res.data.msg : "Não foi possível obter a fila de impressão, verifique sua internet");
          });
      },

      setFilaImpressao(dados, callback) {
        this.$http.post('pdv/impressao/' + localStorage.getItem('key'), { dataPedidos: dados })
          .then(res => {
            if (res.data.success) {
              this.$store.state.printsError = this.prints.filter(p => p.status === '4').length;

              if (callback) {
                callback();
              }
            }

            this.load = false;
          }, res => {
            dados.forEach(d => {
              if (d.id_pedido) {
                this.offline.push(d);
              }
            });

            this.load = false;
          });
      },

      setFilaOffline() {
        if (this.offline.length) {
          this.setFilaImpressao(this.offline, () => {
            this.offline = [];
          });
        }
      },

      removerFila(p) {
        p.status = 5;
        this.setFilaImpressao([p]);
        this.prints = this.prints.filter(print => print !== p);
        this.$store.state.printsError = this.prints.filter(p => p.status === '4').length;
      },

      reemprimirFila(p) {
        if (this.$store.state.printers.find(prin => prin.displayName === p.device)) {
          this.imprimir(p);

        } else {
          if (!p.content) {
            this.$swal(`Para imprimir, acesse a tela do Gestor e selecione o ${p.nome_documento}.`);
            return;
          }

          this.$swal({
            text: "Impressora não encontrada, deseja imprimir na impressora padrão do sistema?",
            buttons: ['Não', 'Sim']
          }).then(res => {
            if (res) {
              p.device = this.impressora.device;

              if (this.usaNovaImpressao) {
                p.content.device = p.device;

                if (p.content.impressora) {
                  p.content.impressora.device = p.device;
                }
              }

              this.imprimir(p);
            }
          });
        }
      },

      imprimir(p) {
        p.content.id_impressao = p.id_impressao;

        if (!this.usaNovaImpressao) {
          p.content.impressora = { device: p.device ? p.device : this.impressora.device };
        }

        document.dispatchEvent(new CustomEvent(this.eventoImpressao, { detail: [p.content] }));
        this.$swal("Pedido enviado para impressão");
      },

      loopFila() {
        clearTimeout(this.filaTimeOut);

        this.filaTimeOut = setTimeout(() => {
          if (this.printServer) {
            this.getFilaImpressao(true);
            this.$emit('checkIfood');
            this.loopFila();
          }
        }, (1000 * 60 * 3));
      },

      wasPrint(e) {
        if (!e.detail) {
          return;
        }

        const id_pedido = e.detail.id_pedido;
        const id_impressao = e.detail.id_impressao;
        const status = e.detail.status;

        if (status && (id_pedido || id_impressao)) {

          // Validar se os pedidos foram impressos
          if (id_pedido && status === 3) {
            this.$store.commit(this.usaNovaImpressao ? 'confirmarImpressaoKanban' : 'addOrderPrints', id_pedido);
          }

          this.setFilaImpressao([e.detail], () => {
            if (status === 3 && this.modalFilaPrint && id_impressao) {
              this.prints = this.prints.filter(p => String(p.id_impressao) !== String(id_impressao));
              this.$store.state.printsError = this.printServer
                ? this.prints.filter(p => p.status !== '1').length
                : this.prints.length;
            }

            if (status === 4) {
              this.$swal({
                title: "Erro ao Imprimir",
                text: e.detail.erro,
                buttons: !this.modalFilaPrint ? ["Fechar", "Abrir fila de impressão"] : "Ok"
              }).then((res) => {
                if (res && !this.modalFilaPrint) {
                  this.$store.state.modalFilaPrint = true;
                }
              });

              this.getFilaImpressao();
            }
          });

        } else if (e.detail.erro) {
          this.$swal(e.detail.erro);
        }
      }
    },

    created() {
      if (!this.isReadOnly) {
        document.addEventListener("wasPrinted", this.wasPrint, false);
      }
    },

    mounted() {
      this.loopFila();
    },

    computed: {
      impressoesRemotas() {
        return this.$store.state.impressoesRemotas;
      },

      usaNovaImpressao() {
        return Number(this.$store.state.configImpressao.migrado_legado || 0) === 1;
      },

      eventoImpressao() {
        return this.usaNovaImpressao ? 'printV2' : 'print';
      },

      modalFilaPrint() {
        return this.$store.state.modalFilaPrint
      },

      empresas() {
        return this.$store.state.empresas;
      },

      impressora() {
        return this.$store.state.impressora
      },

      isReadOnly() {
        return this.$store.state.isReadOnly;
      }
    },

    watch: {
      impressoesRemotas: {
        immediate: true,
        handler() { this.acompanharRemotas(); }
      },
      usaNovaImpressao() { this.acompanharRemotas(); },
      printServer() { this.acompanharRemotas(); },

      modalFilaPrint(res) {
        if (res) {
          this.getFilaImpressao();
        }
      }
    },

    beforeDestroy() {
      this.acompanhamentoCancelado = true;
      clearTimeout(this.filaTimeOut);
      document.removeEventListener('wasPrinted', this.wasPrint, false)
    },
  }
</script>
